import React, { useEffect, useRef } from "react";
import ParaText from "../components/ParaText";
import lottie from "lottie-web";
import AboutInfoItem from "../components/AboutInfoItem";
import ContactBanner from "../components/ContactBanner";

export default function About() {
  const containers = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: containers.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../assets/images/boy.json"),
    });
  });

  return (
    <>
      <div className="container">
        <div className="about__wrapper">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Olaolu Ajibade</span>
              </p>
              <h2 className="about__heading">A Freelance Software Developer</h2>
              <div className="about__info">
                <ParaText>
                  I am a Fullstack Developer from Lagos.
                  Got a Philia for Snow, Movies, Technology and Gaming (and also tesla🤫).
                  Also really like the idea of automating things making life easier.
                  <br/>
                  <br/>
                  My curiosity and love for first principle lead me to the backend side
                  of web development, blockchain and content writing. I am currently taking freelance web development gigs on Fiverr and also very big on contributing to Open source (favourite: Mozilla)
                  <br/>
                  <br/>
                  I'm always ready to collaborate learn, and grow with a supporttive team.
                </ParaText>
              </div>
              <a href="https://drive.google.com/file/d/1Z0uMADtMVNzItZBbtwrGtwvX2jSeZmEe/view?usp=sharing" className="button">Download CV</a>
            </div>
            <div className="right">
              {/* <img src={AboutImg} alt="Laolu-Ajibade img" /> */}
              <div className="containers" ref={containers}></div>
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>
              <AboutInfoItem
                title="School"
                items={["Innocent Comprehensive, High School"]}
              />
              <AboutInfoItem
                title="Polytechnic"
                items={["Mechanical Engineering HND"]}
              />
              <AboutInfoItem
                title="University"
                items={["Computer Science Bsc"]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">MY SKILLS</h1>
              <AboutInfoItem
                title="FrontEnd"
                items={["HTML", "Javascript", "REACT"]}
              />
              <AboutInfoItem
                title="BackEnd"
                items={["Node", "Express", "Python"]}
              />
              <AboutInfoItem
                title="Design"
                items={["Corel-Draw", "figma", "Canva"]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>
              <AboutInfoItem
                title="2010"
                items={["Innocent Comprehensive, High School"]}
              />
              <AboutInfoItem
                title="2014-2016"
                items={["Yaba College of Technology"]}
              />
              <AboutInfoItem
                title="2020-2021"
                items={["Lagos State University"]}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </div>
    </>
  );
}
